import {Cpu, ShieldCheck, Sparkles, TrendingUp} from 'lucide-react'
import FadeIn from '@/components/FadeIn'

const ADVANTAGES = [
  {
    icon: Cpu,
    title: 'Собственные инструменты',
    description: '4 внутренние программы для оптимизации процессов SEO/GEO-продвижения и контроля результата.',
  },
  {
    icon: Sparkles,
    title: '100+ рабочих гипотез',
    description: 'Проверенная база гипотез роста, которую адаптируем под нишу и специфику вашего бизнеса.',
  },
  {
    icon: TrendingUp,
    title: 'Фокус на бизнес-показателях',
    description: 'Ориентируемся не на позиции ради позиций, а на рост обращений, лидов и выручки компании.',
  },
  {
    icon: ShieldCheck,
    title: 'Прозрачность и партнёрство',
    description: 'Понятная отчётность на каждом этапе — от локального рынка до масштабирования на федеральный уровень.',
  },
]

function Advantages() {
  return (
    <section id="advantages" className="bg-neutral-950 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <FadeIn className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-widest text-emerald-400">
            Почему мы
          </span>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-white sm:text-4xl">
            Преимущества работы с нами
          </h2>
        </FadeIn>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {ADVANTAGES.map((item, index) => (
            <FadeIn
              key={item.title}
              delay={index * 60}
              className="flex gap-4 rounded-2xl border border-neutral-800 bg-neutral-900/40 p-7"
            >
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-400/10">
                <item.icon className="h-5.5 w-5.5 text-emerald-400" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-neutral-400">{item.description}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Advantages
